var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM2.5 6.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0zm12.544-5.4c.301-.06.618-.1.956-.1 3.032 0 5.5 2.468 5.5 5.5S19.032 12 16 12c-.338 0-.655-.04-.956-.1a1 1 0 0 1 .392-1.96c.199.04.382.06.564.06 1.928 0 3.5-1.572 3.5-3.5S17.928 3 16 3c-.182 0-.365.02-.564.06a1 1 0 0 1-.392-1.96zm-12.6 14.683C3.9 14.664 5.867 14 8 14s4.1.664 5.557 1.783C15.014 16.903 16 18.52 16 20.38V22a1 1 0 1 1-2 0v-1.62c0-1.11-.584-2.183-1.662-3.01C11.26 16.54 9.728 16 8 16c-1.728 0-3.26.54-4.338 1.37C2.584 18.196 2 19.27 2 20.38V22a1 1 0 1 1-2 0v-1.62c0-1.86.986-3.477 2.443-4.597zm13.623-.831a1 1 0 0 1 1.111-.875C20.813 14.51 24 16.983 24 20.38V22a1 1 0 1 1-2 0v-1.62c0-1.983-1.973-3.95-5.058-4.317a1 1 0 0 1-.875-1.111z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.24158d92c96f7baf1f2762fc07dd2a2a.svg";
export { ForwardRef as ReactComponent };